<template>
  <div id="app">
    <el-menu v-if="!examStatus" :default-active="activeIndex" class="el-menu-demo" mode="horizontal" :ellipsis="false"
      @select="handleSelect" text-color="#8CC4FC" active-text-color="#1989FA">
      <el-menu-item index="0" style="pointer-events: none;position: relative;left: 10vw">
        <template slot="title">
          <div style="color: #1A90EF;font-size: 45px;font-family: 'define-font1';font-weight: 600;">星火数媒</div>
        </template>
      </el-menu-item>
      <el-menu-item index="1" style="margin-left: 20%;">
        <div>首页</div>
      </el-menu-item>
      <el-menu-item index="2">
        <div>备考优库</div>
      </el-menu-item>
      <el-menu-item index="3">
        <div>音视频库</div>
      </el-menu-item>
      <el-menu-item index="4">
        <div>海量题库</div>
      </el-menu-item>
      <el-menu-item index="5">
        <div>在线测评</div>
      </el-menu-item>
      <el-menu-item index="6" v-if="!isLoggedIn">
        <el-button type="text" @click="showLoginDialog" style="color: #0C4BB7;">登录/注册</el-button>
        <div style="color: #0C4BB7;display: inline;margin-left: 10px;" v-if="userSchool">当前位置：{{ userSchool }}</div>
      </el-menu-item>

      <el-submenu index="6" v-if="isLoggedIn">
        <template slot="title">
          <div style="color: #0C4BB7;display: inline;">
            <!-- {{ user && user.name ? `${user.name} (${user.school})` : '未知用户' }} -->
            {{ user.school }}
          </div>
          <!-- <div style="color: #0C4BB7;display: inline;margin-left: 10px;">当前位置：{{ userSchool }}</div> -->
          <el-tooltip style="transform: translateY(-8px);" class="item" effect="dark"
            content="推荐使用edge或Chrome访问，请同意位置授权并不要使用网络代理，否则会导致无法定位或定位出现偏差" placement="top">
            <i style="color: gray;" class="el-icon-info"></i>
          </el-tooltip>
        </template>
        <el-menu-item style="color: #0C4BB7;" @click="logout">退出登录</el-menu-item>
      </el-submenu>
    </el-menu>

    <div :style="{ pointerEvents: isLoggedIn || locationChecked ? 'auto' : 'none' }">
      <router-view />
    </div>

    <el-dialog :visible.sync="isLoginDialogVisible" title="登录" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false">
      <login-form @login-success="handleLoginSuccess" @switch-mode="switchToRegister" />
    </el-dialog>
    <el-dialog :visible.sync="isRegisterDialogVisible" title="注册" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false">
      <register-form @register-success="handleRegisterSuccess" @switch-mode="switchToLogin" />
    </el-dialog>

    <!-- 底部组件 -->
    <footer class="footer" v-if="!examStatus">
      <div class="footer-content">
        <div>版权声明：Copyright©2024 All Rights Reserved 济南鲁云教育科技有限公司</div>
        <div style="color: inherit;">版权所有：<a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2024086438号-1</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import db from "./api/database";
import LoginForm from './components/LoginForm/loginForm.vue';
import RegisterForm from './components/RegisterForm/registerForm.vue';
import { MessageBox } from 'element-ui';
import './assets/font.css'; // 字体库
import watermark from "watermark-dom";
import { checkUserLocation } from './api/GPS';

export default {
  name: 'App',
  components: {
    LoginForm,
    RegisterForm
  },
  data() {
    return {
      activeIndex: '1',
      isLoggedIn: !!localStorage.getItem('user'),
      user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
      isLoginDialogVisible: false,
      isRegisterDialogVisible: false,
      userIP: '',
      userSchool: '', // 新增的变量
      locationChecked: false, // 位置检查状态
      locationMessageVisible: false, // 位置校验提示
      examStatus: false
    };
  },
  watch: {
    // 监听路由变化，根据当前路由设置activeIndex
    $route(to) {
      this.updateActiveIndex(to.path);
    }
  },
  mounted() {
    this.updateActiveIndex(this.$route.path); // 初始化时根据路由设置activeIndex
    watermark.remove();
  },
  created() {
    if (!this.isLoggedIn) {
      this.checkLocationPermission(); // 仅在未登录时检查位置权限
    }
    this.updateUserIPAndSchool();
    this.recordVisit(); // 添加这行代码
  },
  methods: {
    updateActiveIndex(path) {
      switch (path) {
        case '/':
          this.activeIndex = '1';
          break;
        case '/exam-prep':
          this.activeIndex = '2';
          break;
        case '/video-resources':
          this.activeIndex = '3';
          break;
        case '/question-bank':
          this.activeIndex = '4';
          break;
        case '/others':
          this.activeIndex = '5';
          break;
        default:
          this.activeIndex = '1'; // 默认到第一个
      }
    },
    async checkLocationPermission() {
      this.locationMessageVisible = true;

      try {
        const location = await checkUserLocation();
        this.userSchool = location && location.foundSchool ? location.foundSchool : '其他';
        this.locationChecked = true; // 位置校验成功

        if (this.userSchool === '其他') {
          this.$notify({
            title: '您当前不在授权范围内',
            message: this.$createElement('i', { style: 'color: teal' }, [
              '您当前不在授权范围内，可通过账号登录来正常访问网站。',
              '定位失败的原因可能是您未使用校园网络或不在授权范围内，推荐使用Edge或Chrome访问，请同意位置授权并不要使用网络代理。',
            ]),
            duration: 10000 // 显示10秒
          });
          this.isLoginDialogVisible = true;
          this.$router.push('/');
        } else {
          this.$message.closeAll(); // 关闭所有消息提示
        }
      } catch (error) {
        console.error('获取位置失败:', error);
        this.$message.error('获取位置信息失败，请重试');
        this.isLoginDialogVisible = true;
        this.$router.push('/');
      }
    },
    async recordVisit() {
      const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
      const phone = user ? user.phone : null;
      const location = JSON.parse(localStorage.getItem('location'));

      const locationNew = { foundSchool: user.school }

      
      const visitData = {
        timestamp: new Date().toISOString(),
        type: 'websiteTraffic',
        phone: phone,
        location: locationNew
      };

      try {
        await db.collection('Logs').add(visitData);
        console.log('访问记录成功:', visitData);
      } catch (error) {
        console.error('记录访问失败:', error);
      }
    },
    async updateUserIPAndSchool() {
      try {
        const location = JSON.parse(localStorage.getItem('location'));
        this.userSchool = location && location.foundSchool ? location.foundSchool : '未能获取学校信息';
      } catch (error) {
        console.error('Error fetching IP or school:', error);
        this.userSchool = '未能获取学校信息';
      }
    },
    handleSelect(key, keyPath) {
      console.log('Selected:', key, 'Path:', keyPath);
      if (key == 1) {
        this.$router.push('/');
      } else if (key == 2) {
        this.$router.push('/exam-prep');
      } else if (key == 3) {
        this.$router.push('/video-resources');
      } else if (key == 4) {
        this.$router.push('/question-bank');
      } else if (key == 5) {
        this.$router.push('/others');
      }
    },
    showLoginDialog() {
      this.isLoginDialogVisible = true;
    },
    handleLoginSuccess(user) {
      this.user = user;
      this.isLoggedIn = true;
      this.isLoginDialogVisible = false;
      this.updateUserIPAndSchool();
      console.log('登录成功:', user);
      this.$message.success('登录成功!');
    },
    handleRegisterSuccess() {
      this.isRegisterDialogVisible = false; // 关闭注册对话框
      this.isLoginDialogVisible = true; // 显示登录对话框
      console.log('注册成功，请登录');
      this.$message.success('注册成功，请登录'); // 提示用户登录
    },
    switchToLogin() {
      this.isRegisterDialogVisible = false;
      this.isLoginDialogVisible = true;
    },
    switchToRegister() {
      this.isLoginDialogVisible = false;
      this.isRegisterDialogVisible = true;
    },
    logout() {
      this.$confirm('确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('user');
        this.isLoggedIn = false;
        this.user = null;
        console.log('已退出登录');
        this.checkLocationPermission();
      }).catch(() => {
        console.log('取消退出登录');
      });
    }
  }
};
</script>


<style>
.el-menu-demo {
  --el-menu-background-color: #f8f9fa;
  --el-menu-hover-background-color: #a7bdef;
}

.menu-link {
  text-decoration: none;
  color: inherit;
}

body {
  display: block;
  margin: 0;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #f8f9fa;
  text-align: center;
  padding: 5px 0;
  color: #818A92;
  font-size: 10px;
  border-top: 1px solid #eaeaea;
}

.footer-content>div {
  margin: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue